import React, { useEffect } from 'react';
import Meta from './../components/Meta';
import AuthSection from './../components/auth/AuthSection';
import { useAuth } from './../util/auth';
import { useRouter } from './../util/router';

function AuthPage(props) {
  const auth = useAuth();
  const router = useRouter();

  useEffect(() => {
    const type = router.query.type;
    if (auth.user && (type === 'signin' || type === 'signup' || !type)) {
      router.replace(router.query.next || '/feed');
    }
  }, [auth.user, router]);

  return (
    <>
      <Meta title="Auth" />
      <AuthSection
        type={router.query.type}
        providers={['google']}
        afterAuthPath={router.query.next || ''}
        authError={router.query.authError || ''}
      />
    </>
  );
}

export default AuthPage;
